import {Component, OnInit} from '@angular/core';

@Component({
  selector: 'app-citizen-services-provicion-means',
  templateUrl: './citizen-services-provicion-means.component.html',
  styleUrls: ['./citizen-services-provicion-means.component.scss']
})
export class CitizenServicesProvicionMeansComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
